import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

import ConNav from './conNav';
import ConLeft from './conLeft';
import VideoBox from './videoBox';
class Content extends React.PureComponent {
    constructor() {
        super();
        this.conNavHeader = {
            navCenter: '公司简介',
            navRight: '凤凰新媒体',
        };
    }

    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.pageBody}>
                <div className={styles.page}>
                    <div className={styles.pageHead}>
                        <div className={styles.pageEnd}>
                            <div className={styles.myContent}>
                                <ConNav conNavHeader={this.conNavHeader} />
                                <Chip
                                    id="193384"
                                    type="static"
                                    title="凤凰新媒体公司简介"
                                    groupName="凤凰新媒体公司简介"
                                    content={content}>
                                    <ConLeft />
                                </Chip>
                                <Chip
                                    id="255933"
                                    type="recommend"
                                    title="凤凰新媒体宣传片"
                                    groupName="凤凰新媒体宣传片"
                                    content={content}>
                                    <VideoBox />
                                </Chip>
                            </div>
                            <div className={styles.clear} />
                        </div>
                    </div>
                </div>
                <div className={styles.border} />
            </div>
        );
    }
}

export default Content;
